import { Inject, Injectable } from '@angular/core';
import { ApiService } from '../shared/services/api.service';
import { HttpClient } from '@angular/common/http';
import { API_CONFIG, ApiConfig } from '@ff/api';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private _endpoint;

  constructor(
    private _apiService: ApiService,
    private _http: HttpClient,
    @Inject(API_CONFIG) _apiConfig: ApiConfig
  ) { 
    this._endpoint = _apiConfig.host;
  }

  getToken() {
    return this._http.get( this._endpoint + '/sanctum/csrf-cookie', {withCredentials: true, observe: 'response' as 'response'});
  }

  refreshToken() {
    return this._http.get( this._endpoint + '/auth/refresh');
  }

  test() {
    return this._http.get( this._endpoint + '/test', {withCredentials: true});
  }
}
